/* eslint-disable no-unused-vars, no-useless-constructor*/
import React from 'react';
import PropTypes from 'prop-types';
import {Fade} from 'react-reveal';
import { Row, Col } from 'react-bootstrap';

import MicrositeSection from '../MicrositePage/MicrositeSection/MicrositeSection';
import BaseComponent from "../../../panther/components/base/BaseComponent";
import ComparatorContainer from "./ComparatorContainer";

import detailBefore from "../../../resources/img/detail-before.png";
import detailAfter from "../../../resources/img/detail-after.png";
import overviewBefore from "../../../resources/img/current_status.png";
import overviewAfter from "../../../resources/img/scenario.png";

import './style.css';

class Service1 extends BaseComponent {
    constructor(props) {
        super(props);
    }

    render() {
        let content = this.renderContent();

        return (
            <MicrositeSection
                id={this.props.id}
                name={this.props.name}
                textCentered={this.props.textCentered}
                content={content}
                colorTheme="light"
            />
        );
    }

    renderContent(){
        return (
            <div>
                <Row className="show-grid">
                    <Fade>
                        <Col xs={12} sm={10} smOffset={1} md={10} mdOffset={1} lg={8} lgOffset={2}>
                            <p className="centered">An interactive web-based modelling tool is available for you. </p>
                            <p className="centered"> It allows you to model a distribution of urban heat stress based on the land structure and development of your city.  The model works at 100m spatial resolution which allows you to follow the effect of urban heat island for wider area of the city and its hinterground. You start with the current land cover structure of the city, which is defining the current magnitude and distribution of the heat stress over the city. Then, you can model any potential scenario of the city development in the future, reflecting e.g. various urban-planning strategies, and follow the impact of this land cover change on the urban heat stress magnitude and distribution. For example, a densification of the city will be reflected in increase of the urban heat stress. On the other hand, the extension of urban green areas will help to mitigate the urban heat.</p>
                        </Col>
                    </Fade>
                </Row>
                <Row className="show-grid">
                    <Fade left distance="30px" delay={500}>
                        <Col xs={12} xsOffset={0} sm={12} smOffset={0} md={12} mdOffset={0} lg={12} lgOffset={0}>
                            <ComparatorContainer
                                maxWidth={400}
                                leftImageSrc={overviewBefore}
                                rightImageSrc={overviewAfter}
                                leftCaption="Current status"
                                rightCaption="Development scenario"
                                bottomLabel="Analysis: GISAT © 2019"
                            />
                        </Col>
                    </Fade>
                </Row>
                <Row className="show-grid">
                    <Fade>
                        <Col xs={12} sm={10} smOffset={1} md={10} mdOffset={1} lg={8} lgOffset={2}>
                            <p className="centered">You can start at the city level and model and compare city development scenarios for the future. But you can also go the higher level of spatial detail and model how the various scenarios of potential development of specific sites in the city will be reflected in local level of heat stress.</p>
                        </Col>
                    </Fade>
                </Row>
                <Row className="show-grid">
                    <Fade left distance="30px" delay={500}>
                        <Col xs={12} xsOffset={0} sm={12} smOffset={0} md={12} mdOffset={0} lg={12} lgOffset={0}>
                            <ComparatorContainer
                                maxWidth={500}
                                leftImageSrc={detailBefore}
                                rightImageSrc={detailAfter}
                                leftCaption="Current status"
                                rightCaption="Development scenario"
                                bottomLabel="Analysis: GISAT © 2019"
                            />
                        </Col>
                    </Fade>
                </Row>
            </div>
        );
    }
}

Service1.propTypes = {
    id: PropTypes.string,
    name: PropTypes.string,
    textCentered: PropTypes.bool
};

export default Service1;
